
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';


import Mynavbar from './components/navbar';

function App() {
  return (
    
      <div className="App">
        <Mynavbar/>
        
      </div>
    
  );
}

export default App;
